<template>
  <div class="hide-act">
    <p>
      Para cada una de las siguientes situaciones, seleccione el tipo de decisión que ha tomado Juliana, haciendo clic en el elemento de las lista que considere.
    </p>
    <div id="despedida-actdrag" tabindex="0" role="alert" v-if="preguntaNum >= 3">
      <div>&nbsp</div>
      <p>
        Para tomar decisiones efectivas y alcanzar las metas es importante saber administrar el dinero.<br> Puedes continuar con el curso</p>
    </div>

    <template v-for="(pregs, index) in preguntas" v-if="index === preguntaNum">
      <div :key="index+'pregs'">
        <div id="preguntaAcc" tabindex="0">
          <p>{{pregs.preg}}</p>
        </div>
        <div>&nbsp</div>
        <select v-model="pregs.resp">
          <option disabled value="">Seleccione una opción</option>
          <option v-for="item in respuestas">{{item.opcion}}</option>
        </select>
      </div>
    </template>
    <button @click="revisar()" v-if="preguntaNum < 3">Revisar respuesta</button>

    <v-dialog role="alert" v-model="respuesta" width="600" height="200">
      <v-card>
        ¡Muy bien!
        <v-flex text-xs-center>
          <ui-button class="mt-2 mb-4" :content="'Cerrar'" :aria="'Cerrar'" @click.native="cerrarRetro()">
          </ui-button>
        </v-flex>
      </v-card>
    </v-dialog>

    <v-dialog role="alert" v-model="respuestaMal" width="600" height="200">
      <v-card>
        ¡Incorrecto!<br> {{retroText}}
        <br> Inténtelo de nuevo

        <v-flex text-xs-center>
          <ui-button class="mt-2 mb-4" :content="'Cerrar'" :aria="'Cerrar'" @click.native="cerrarRetroMal()">
          </ui-button>
        </v-flex>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: "",
      selectedTwo: "",
      retroalimentacion: "",
      respuesta: false,
      respuestaMal: false,
      preguntaNum: 0,
      retroText: "",
      preguntas: [
        {
          resCorr: "Decisión eficiente",
          preg:
            "1. Destinar un porcentaje adicional de su salario mensual como ahorro fijo para la cuota inicial de su casa.",
          resp: ""
        },
        {
          resCorr: "Decisión eficaz",
          preg: "2. Invertir en un CDT que le genere un interés adicional.",
          resp: ""
        },
        {
          resCorr: "Decisión efectiva",
          preg:
            "3. Firmar una promesa de compraventa de la casa que desea con una constructora o fiduciaria.",
          resp: ""
        }
      ],
      respuestas: [
        {
          opcion: "Decisión eficaz",
          retro:
            "Incorrecto. Recuerde que para ser eficaz es importante maximizar los recursos con los que se cuenta."
        },
        {
          opcion: "Decisión efectiva",
          retro:
            "Incorrecto. Recuerde que ser efectivo implica asegurarse de causar el impacto deseado."
        },
        {
          opcion: "Decisión eficiente",
          retro:
            "Incorrecto. Recuerde que para ser eficiente es importante hacer lo que se debe hacer."
        }
      ]
    };
  },
  methods: {
    cerrarRetro() {
      this.respuesta = false;
      this.preguntaNum++;
      if (this.preguntaNum >= 3) {
        this.$store.commit("nextShow", true);
      }      
      if (this.preguntaNum < 3) {
        setTimeout(function() {
          document.getElementById("preguntaAcc").focus();
        }, 100);        
      } else if (this.preguntaNum >= 3) {
        setTimeout(function() {
          document.getElementById("despedida-actdrag").focus();
        }, 100);           
      }
    },
    cerrarRetroMal() {
      this.respuestaMal = false;
      document.getElementById("preguntaAcc").focus();
    },
    checkResp(event) {
      if (event.resp === event.resCorr) {
        this.respuesta = true;
      } else {
        this.respuestaMal = true;
      }
      var retroInt = this.respuestas.filter(elem => {
        return event.resp === elem.opcion;
      });
      this.retroText = retroInt[0].retro;
    },
    revisar() {
      if (
        this.preguntas[this.preguntaNum].resp ===
        this.preguntas[this.preguntaNum].resCorr
      ) {
        this.respuesta = true;
      } else {
        this.respuestaMal = true;
      }
      var retroInt = this.respuestas.filter(elem => {
        return this.preguntas[this.preguntaNum].resp === elem.opcion;
      });
      this.retroText = retroInt[0].retro;
    }
  }
};
</script>

<style lang="scss" scoped>
select {
  -webkit-appearance: menulist;
  border: solid 1px red;
}
.hide-act{
  width: 5px;
  height: 5px;
  overflow: hidden;
  position: absolute;
  left: -9999px;
}
</style>





// WEBPACK FOOTER //
// Actividad-drag-back.vue?09f91b57